import { lazy } from 'react';

export const LanguagesYouSpeak = lazy(() => import('./LanguagesYouSpeak'));
export const LanguagesYouSpeakThanks = lazy(() => import('./LanguagesYouSpeakThanks'));
